import { useCallback, useEffect } from 'react';

import { useAnalyticsEvents } from '@atlaskit/teams-app-internal-analytics/use-analytics-events';

import { useTeamsPermissionsStore } from './teams-permission-store';
import { type TeamsPermissionsService } from './teams-permission-store/types';

export const useTeamsPermissionsService: TeamsPermissionsService = (
	scope,
	{ enabled, attributes } = { enabled: false, attributes: {} },
) => {
	// backwards compatibility allow orgId to be passed as a string
	const { orgId, cloudId } =
		typeof scope === 'string' || !scope ? { orgId: scope, cloudId: undefined } : scope;

	const [state, { getPermissions }] = useTeamsPermissionsStore();
	const { fireEvent } = useAnalyticsEvents();

	const fetchData = useCallback(async () => {
		getPermissions(
			{ orgId, cloudId, enabled },
			{
				onFetch: () => {
					// @ts-expect-error - hyphenated event names are not supported in the analytics spec
					fireEvent('operational.use-team-permissions.fetched', {
						userId: attributes?.userId,
						orgId,
						cloudId,
					});
				},
			},
		);
	}, [orgId, cloudId, enabled, getPermissions, attributes?.userId, fireEvent]);

	useEffect(() => {
		fetchData();
	}, [fetchData]);

	return {
		loading: state.isLoading,
		data: state.permissionsResponse,
		error: state.error,
		...state,
	};
};
